import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { fontSize } from '@mui/system'

import { FONTS } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  switchWrapper: {
    '&&': {
      marginTop: 0,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: '32px',
      width: '100%',
      fontSize: '14px'
    },
  },
  selectionSubtext: {
    '&&': {
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.34,

      wordWrap: 'break-word',
      wordBreak: 'break-word',
      whiteSpace: 'normal',

      [theme.breakpoints.down('tablet')]: {
        fontSize: FONTS.SIZES.xl,
        fontWeight: 'bold',

        color: theme.palette.custom.darkBlue2,
      },
    },
  },
}))
